import BlockingViewer from "./components/blocking_viewer.jsx"

export default function Home() {
  return (
    <main>
      <BlockingViewer />
    </main>
  )
}
